<template>    
    <div class="card card-primary card-outline card-outline-tabs">
        <div class="card-header p-0 border-bottom-0">
            <ul class="nav nav-tabs d-flex flex-column flex-md-row" id="custom-tabs-five-tab" role="tablist">
                <li class="nav-item">
                    <a 
                        :class="tab === 'precios' ? 'nav-link active' : 'nav-link'" 
                        class="text-center"
                        data-cy="session-config-tab-pricing"
                        href="#"
                        @click.prevent="tab = 'precios'"
                    >
                        Configurar precios por regiones
                    </a>
                </li>
                <li class="nav-item" v-if="showRecintoAnexoTab">
                    <a 
                        :class="['nav-link', 'text-center', { 'active': tab === 'recintoAnexo' }]"
                        data-cy="session-config-tab-leaflet"
                        href="#"
                        @click.prevent="tab = 'recintoAnexo'"
                    >
                        Configurar precios por butacas/plazas
                    </a>
                </li>
                <li class="nav-item">
                    <a 
                        :class="['nav-link', 'text-center', { 'active': tab === 'descuentos' }]"
                        href="#"
                        @click.prevent="tab = 'descuentos'"
                    >
                        Configurar cupones de descuento
                    </a>
                </li>
                <li class="nav-item">
                    <a 
                        :class="['nav-link', 'text-center', { 'active': tab === 'promociones' }]"
                        href="#"
                        @click.prevent="tab = 'promociones'"
                    >
                        Promociones
                    </a>
                </li>
                <li class="nav-item" v-if="evento.place_obj.tipo_svg === 2">
                    <a 
                        :class="tab === 'visibilidadReducida' ? 'nav-link active' : 'nav-link'" 
                        href="#"
                        @click.prevent="tab = 'visibilidadReducida'"
                    >
                        Configurar butacas/plazas de visibilidad reducida
                    </a>
                </li>
            </ul>
        </div>
        <div class="card-body">
            <div class="tab-content">
                <div class="tab-pane fade active show">
                    <transition name="fade" mode="out-in">
                        <div key="1" class="overlay-wrapper" v-if="tab === 'precios'">
                            <Precios :evento_id="evento_id" :sesion_id="sesion_id"/>
                        </div>
                        <div key="2" class="overlay-wrapper" v-if="tab === 'descuentos'">
                            <Vouchers :event_id="evento_id" :session_id="sesion_id"/>
                        </div>
                        <div key="3" class="overlay-wrapper" v-if="tab === 'promociones'">
                            <Promociones :event_id="evento_id" :session_id="sesion_id"/>
                        </div>
                        <div key="4" class="overlay-wrapper" v-if="tab === 'visibilidadReducida' && evento.place_obj.tipo_svg === 2">
                            <DescuentoButacas :evento="evento"
                                              :evento_id="Number(evento_id)"
                                              :sesion_id="Number(sesion_id)"
                            />
                        </div>
                        <div key="5" class="overlay-wrapper" v-if="tab === 'recintoAnexo'">
                            <PreciosPlazas v-if="evento.place_obj.tipo_svg === 1" :place="evento.place_obj" />
                            <PreciosButacas 
                                v-else-if="evento.place_obj.tipo_svg === 2"
                                :evento="evento"
                                :evento_id="Number(evento_id)"
                                :sesion_id="Number(sesion_id)"
                            />
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>              
</template>

<script setup>
    import { computed, ref } from 'vue'

    import Precios from './Precios'
    import Vouchers from '@/views/backend/events/sesiones/conrecinto/Vouchers'
    import Promociones from '@/views/backend/events/sesiones/conrecinto/Promociones'
    import PreciosPlazas from '@/components/backend/eventos/sesiones/plazas/PreciosPlazas'
    import PreciosButacas from '@/components/backend/eventos/sesiones/plazas/PreciosButacas'
    import DescuentoButacas from '@/components/backend/eventos/sesiones/visibilidad-reducida/DescuentoButacas.vue'

    const props = defineProps({
        evento_id: {
            type: [Number, String],
            required: true
        },
        sesion_id: {
            type: [Number, String],
            required: true
        },
        evento: {
            type: Object,
            required: true
        }
    })

    const tab = ref('precios')

    const isTipoSvg2 = computed(() => props.evento.place_obj.tipo_svg === 2)
    const hasRegionesAnexas = computed(() => props.evento.place_obj.tipo_svg === 1 && props.evento.tiene_regiones_anexas)
    const showRecintoAnexoTab = computed(() => {
        return isTipoSvg2.value
            || hasRegionesAnexas.value
            || (props.evento.place_obj.tipo_svg === 1 && !props.evento.tiene_regiones_anexas)
    })
</script>
